export default __webpack_public_path__ + "static/media/stars.b64ce90b.svg";